<footer>
    <div class="footer-top">
        <div class="footer-text">
            <h3>¡Ahora todos los beneficios<br />al alcance de tu mano!</h3>
            <p>
                Descargá la nueva app de PASS<br />
                y comenzá a disfrutar una nueva<br />
                experiencia y recibí<br />
                notificaciones de nuevos beneficios
            </p>

            <button><a href="https://back.losandespass.com.ar/frames/forms/LAP/Suscripcion">Suscribirme para usar estos beneficios</a></button>
        </div>
        <div class="footer-media">
            <div class="footer-left">
                <img src="assets/icons/pass.png" alt="Logo PASS" class="footer-pass-logo" />
                <div class="store-buttons">
                    <a href="https://play.google.com/store/apps/details?id=com.losandes.pass"> <img src="assets/img/google-play.png" alt="Google Play" /> </a>
                    <a href="https://apps.apple.com/us/app/mi-los-andes-pass/id6747127296"> <img src="assets/img/app-store.png" alt="App Store" /> </a>
                </div>
            </div>

            <div class="phone-footer-container">
                <img src="assets/img/phone-footer.png" alt="App PASS" class="phone-footer-image" />
            </div>

            <div class="qr-footer-container">
                <p>Escaneá el Código QR y<br />descargá la App en tu celular.</p>
                <div class="qr">
                    <p>Ios </p>
                    <img src="assets/img/ios-qr.png" alt="Código QR PASS" class="qr-footer-image" />
                </div>
                <div class="qr">
                    <p>Android </p>
                    <img src="assets/img/android-qr.png" alt="Código QR PASS" class="qr-footer-image" />
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom">
            <div class="logo">
                <img src="assets/icons/pass-blue.png" alt="Logo" />
            </div>
            <div class="footer-content">
                <div class="footer-section">
                    <ul class="links">
                        <li><a href="#">Como anunciar</a></li>
                        <li><a href="https://sucursales.losandespass.com.ar/Forms/Default.aspx">Para comercios</a></li>
                        <li><a href="https://back.losandespass.com.ar/frames/forms/LAP/AdhesionComercios">Adherir mi marca </a></li>
                        <li><a href="#">Preguntas frecuentes</a></li>
                        <li><a href="#">Catálogo de beneficios</a></li>
                        <li><a href="https://docs.google.com/document/d/19nD9VNhIlRm-uiFr2_brZSExiCHtcAq0/edit?usp=sharing&ouid=105717146563518239894&rtpof=true&sd=true">Reglamento</a></li>
                    </ul>
                </div>

                <div class="footer-section">
                    <h3 class="social-title">Contactos</h3>
                    <ul class="social-icons">
                        <li>
                            <a href="https://www.instagram.com/losandes_pass/"><img src="assets/icons/instagram-icon-blue.svg" alt="Instagram" /></a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/LosAndesPass?locale=es_LA"><img src="assets/icons/facebook-icon.svg" alt="Facebook" /></a>
                        </li>
                    </ul>
                    <ul class="social-icons-a">
                        <li><a href="mailto:contacto@losandespass.com.ar">contacto&#64;losandespass.com.ar</a></li>
                    </ul>
                </div>
                

                <div class="footer-section">
                    <h3>Descargá nuestra app</h3>
                    <div class="downloads">
                       <a href="https://play.google.com/store/apps/details?id=com.losandes.pass">  <img src="assets/img/google-play.png" alt="Google Play" /></a> 
                        <a href="https://apps.apple.com/us/app/mi-los-andes-pass/id6747127296"> <img src="assets/img/app-store.png" alt="App Store" /></a> 
                    </div>
                </div>

                <div class="footer-section">
                    <h3>Atención al cliente</h3>
                    <div class="customer-service">
                    <ul>
                       <li>
                        <a href="mailto:suscripciones@losandes.com.ar"><b>Correo:</b> suscripciones&#64;losandes.com.ar</a>
                        </li>
                        <li>
                        <a href="tel:+5492613042250"><b>Teléfono:</b> +5492613042250</a>
                        </li>
                        <li>
                        <a href="#"><b>Dirección:</b> Av. San Martín 1049, Mendoza, Argentina</a>
                        </li>
                        <li>
                        <a href="https://docs.google.com/document/d/14KhJVw0r6LWl_tXzqftLRdQC6euQkqIGBs6x5HmUiSM/edit?usp=sharing"><b>Política de privacidad</b></a>
                        </li>

                    </ul>
                </div>
                </div>
            </div>

             <p class="consumer-defense">
                Dirección Gral. De Defensa y Protección del Consumidor. Defensa de los
                Consumidores, para reclamos ingrese aquí.
            </p>
    </div>
</footer>